import React from "react";
import { useState } from "react";
import { Row, Col } from "reactstrap";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';

export default function DetalhadoDadosDRE({ tableDetalhadoBI }) {

  const [camposDataTable, setCamposDataTable] = useState([
    { tipo: "titulo", open: true, keyparent: '', icon: false, key: 'RECEITABRUTA', label: "RECEITA BRUTA", codigo: "totalWaterfall.totalReceitaBruta" },
    { tipo: "subtitulo", open: false, keyparent: 'RECEITABRUTA', icon:false, key: 'SERVICO', label: "SERVIÇO", codigo: "receitaBrutaServico" },
    { tipo: "campo", open: false, keyparent: 'SERVICO', label: "COMISSÃO", codigo: "comissao" },
    { tipo: "campo", open: false, keyparent: 'SERVICO', label: "SEGURO APARELHO", codigo: "seguroAparelho" },
    { tipo: "campo", open: false, keyparent: 'SERVICO', label: "RECARGA", codigo: "recarga" },
    { tipo: "subtitulo", open: false, keyparent: 'RECEITABRUTA', icon:false,  key: 'PRODUTO', label: "PRODUTO", codigo: "receitaBrutaProduto" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "REBATE", codigo: "rebate" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "ADM", codigo: "adm" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "PRICE OFERTA", codigo: "priceOferta" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "PRICE PROTECTION", codigo: "priceProtection" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "PRICE BACK", codigo: "priceBack" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "OUTROS", codigo: "outrosReembolso" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "APARELHO", codigo: "aparelho" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "CHIP", codigo: "chip" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO', label: "ACESSÓRIO", codigo: "acessorio" },
    { tipo: "titulo", open: true, keyparent: '', icon:false, key: 'IMPOSTO', label: "IMPOSTO", codigo: "totalWaterfall.totalImposto" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Serviço", codigo: "pisCofinsServico" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Seguro", codigo: "pisCofinsSeguro" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Chip", codigo: "pisCofinsChip" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Recarga", codigo: "pisCofinsRecarga" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Aparelho", codigo: "pisCofinsAparelho" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "PIS/COFINS - Acessório", codigo: "pisCofinsAcessorio" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "ICMS - Chip", codigo: "icmsChip" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "ICMS - Aparelho", codigo: "icmsAparelho" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "ICMS - Acessório", codigo: "icmsAcessorio" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "ICMS-ST Aparelho", codigo: "icmsSTAparelho" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "ISS", codigo: "iss" },
    { tipo: "campo", open: false, keyparent: 'IMPOSTO', label: "SIMPLES NACIONAL", codigo: "totalImpostoPieChart.totalImpostoSimplesNacional" },
    { tipo: "titulo", open: true, keyparent: '',icon:false, key: 'RECEITALIQUIDA', label: "RECEITA LÍQUIDA", codigo: "totalWaterfall.totalReceitaLiquida" },
    { tipo: "subtitulo", open: false, keyparent: 'RECEITALIQUIDA', key: 'CMV', label: "CMV", codigo: "totalWaterfall.totalCmv" },
    { tipo: "campo", open: false, keyparent: 'CMV', label: "APARELHO - CMV", codigo: "cmvAparelho" },
    { tipo: "campo", open: false, keyparent: 'CMV', label: "CHIP - CMV", codigo: "cmvChip" },
    { tipo: "campo", open: false, keyparent: 'CMV', label: "ACESSÓRIO - CMV", codigo: "cmvAcessorio" },
    { tipo: "titulo", open: true, keyparent: '', key: 'RECEITAOPERACIONAL', label: "RECEITA OPERACIONAL", codigo: "totalWaterfall.totalReceitaOperacional" },
    { tipo: "campo", open: false, keyparent: 'RECEITAOPERACIONAL', label: "PRODUTO", codigo: "receitaOperacionalProduto" },
    { tipo: "campo", open: false, keyparent: 'RECEITAOPERACIONAL', label: "SERVIÇO", codigo: "receitaOperacionalServico" },
    { tipo: "titulo", open: true, keyparent: '', key: 'DESPESA', label: "DESPESA", codigo: "totalWaterfall.totalDespesa" },
    { tipo: "subtitulo", open: false, keyparent: 'DESPESA', key: 'DESPESAPESSOAL', label: "DESPESA PESSOAL", codigo: "totalDespesaPieChart.totalPessoal" },
    { tipo: "campo", open: false, keyparent: 'DESPESAPESSOAL', label: "VENDEDOR", codigo: "vendedor" },
    { tipo: "campo", open: false, keyparent: 'DESPESAPESSOAL', label: "GERENTE", codigo: "gerente" },
    { tipo: "campo", open: false, keyparent: 'DESPESAPESSOAL', label: "CAIXA", codigo: "caixa" },
    { tipo: "campo", open: false, keyparent: 'DESPESAPESSOAL', label: "ADMINISTRATIVO", codigo: "administrativo" },
    { tipo: "subtitulo", open: false, keyparent: 'DESPESA', key: 'DESPESAOCUPACAO', label: "DESPESA OCUPAÇÃO", codigo: "totalDespesaPieChart.totalOcupacao" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "ALUGUEL", codigo: "aluguel" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "ALUGUEL PERCENTUAL", codigo: "aluguelPorcentual" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "CONDOMÍNIO", codigo: "condominio" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "FUNDO PROMOÇÃO", codigo: "fundoPromocao" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "DÉCIMO TERCEIRO ALUGUEL", codigo: "decimoTerceiroAluguel" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "IPTU", codigo: "iptu" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "CRÉDITO PIS/COFINS", codigo: "creditoPISCOFINS" },
    { tipo: "campo", open: false, keyparent: 'DESPESAOCUPACAO', label: "OUTRAS", codigo: "outras" },
    { tipo: "subtitulo", open: false, keyparent: 'DESPESA', key: 'DESPESACARTAO', label: "DESPESA COM CARTÃO", codigo: "totalDespesaPieChart.totalCartao" },
    { tipo: "campo", open: false, keyparent: 'DESPESACARTAO', label: "TAXA CARTÃO MDR", codigo: "taxaCartaoMDR" },
    { tipo: "campo", open: false, keyparent: 'DESPESACARTAO', label: "ALUGUEL DA MÁQUINA", codigo: "aluguelMaquina" },
    { tipo: "subtitulo", open: false, keyparent: 'DESPESA', key: 'DESPESAESTRUTURAL', label: "DESPESA ESTRUTURAL", codigo: "totalDespesaPieChart.totalEstrutural" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "AÇÃO DE VENDAS", codigo: "acoesVendas" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "CONTABILIDADE", codigo: "contabilidade" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "ENERGIA", codigo: "energiaTaxas" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "JURÍDICO", codigo: "juridico" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "LIMPEZA", codigo: "limpeza" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "MANUTENÇÃO", codigo: "manutencao" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "MATERIAL DE ESCRITÓRIO", codigo: "materiais" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "MOTOBOY", codigo: "motoboy" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "SEGURO LOJA", codigo: "seguros" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "SISTEMAS", codigo: "sistemas" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "TELEFONE E INTERNET", codigo: "telefoniaInternet" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "OUTROS", codigo: "outros" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "EVENTOS", codigo: "eventos" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "SANEAMENTO BÁSICO", codigo: "saneamentoBasico" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "SEGURANÇA MONITORAMENTO", codigo: "segurancaMonitoramento" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "CONTRIBUIÇÃO SINDICAL", codigo: "contribuicaoSindical" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "EMPRESA TERCEIRIZADA", codigo: "empresaTerceirizada" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "UNIFORMES", codigo: "uniformes" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "RECRUTAMENTO SELEÇÃO", codigo: "recrutamentoSelecao" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "PROCESSO JUDICIAL", codigo: "processoJudicial" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "DESPESA GRÁFICA", codigo: "despesaGrafica" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "FRETES CARRETO", codigo: "fretesCarreto" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "REPRESENTAÇÕES VIAGENS", codigo: "representacoesViagensTransporte" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "IRALUGUEL", codigo: "irAluguel" },
    { tipo: "campo", open: false, keyparent: 'DESPESAESTRUTURAL', label: "PERDA ROUBO BAIXA ESTOQUE", codigo: "perdaRouboBaixaEstoque" },
    { tipo: "titulo", open: true, keyparent: '', key: 'EBITDA', label: "EBITDA", codigo: "totalWaterfall.totalEbitda" },
    { tipo: "titulo", open: true, keyparent: '', key: 'PERCENTUALEBTIDA', label: "% EBITDA", codigo: "percentualEbitda" },
    { tipo: "tituloIndicador", open: true, keyparent: '', key: 'INDICADORES', label: "INDICADORES", codigo: "" },
    { tipo: "subtitulo", open: false, keyparent: 'INDICADORES', label: "QTD PDV", codigo: "qtdPDV" },
    { tipo: "subtitulo", open: false, keyparent: 'INDICADORES', key: 'FUNCIONARIOS', label: "FUNCIONÁRIOS", codigo: "" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "VENDEDOR | QTD", codigo: "vendedorQtd" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "VENDEDOR | UNITÁRIO", codigo: "vendedorUnitario" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "GERENTE | QTD", codigo: "gerenteQtd" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "GERENTE | UNITÁRIO", codigo: "gerenteUnitario" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "CAIXA | QTD", codigo: "caixaQtd" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "CAIXA | UNITÁRIO", codigo: "caixaUnitario" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "ADMINISTRATIVO | QTD", codigo: "administrativoQtd" },
    { tipo: "campo", open: false, keyparent: 'FUNCIONARIOS', label: "ADMINISTRATIVO | UNITÁRIO", codigo: "administrativoUnitario" },
    { tipo: "subtitulo", open: false, keyparent: 'INDICADORES', key: 'PRODUTO2', label: "PRODUTO", codigo: "" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "APARELHO | QTD", codigo: "aparelhoQtd" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "APARELHO | TKM", codigo: "aparelhoTKM" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "APARELHO | CMV", codigo: "aparelhoTKMCMV" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "CHIP | QTD", codigo: "chipQtd" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "CHIP | TKM", codigo: "chipTKM" }, 
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "CHIP | CMV", codigo: "chipTKMCMV" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "ACESSÓRIO | QTD", codigo: "acessorioQtd" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "ACESSÓRIO | TKM", codigo: "acessorioTKM" },
    { tipo: "campo", open: false, keyparent: 'PRODUTO2', label: "ACESSÓRIO | CMV", codigo: "acessorioTKMCMV" },
    { tipo: "subtitulo", open: false, keyparent: 'INDICADORES', key: 'VOLUMEDATASYS', label: "VOLUME DATASYS", codigo: "" },
    { tipo: "campo", open: false, keyparent: 'VOLUMEDATASYS', label: "PÓS PURO", codigo: "posPuro" },
    { tipo: "campo", open: false, keyparent: 'VOLUMEDATASYS', label: "CONTROLE", codigo: "controle" },
    { tipo: "campo", open: false, keyparent: 'VOLUMEDATASYS', label: "UPGRADE", codigo: "upgrade" }
  ]);
 
  const OnOpenChild = (key) => {
    let newdata = camposDataTable.map((item) => (
      item.key === key ? item = { ...item, icon: !item.icon } : item,
      item.keyparent === key ? item = { ...item, open: !item.open } : item 
    ))

    // Atualiza o icone dos subtitulos
    newdata = newdata.map((item) => (
      item.tipo == "subtitulo" && item.keyparent === key ? item = { ...item, icon: (!newdata.filter(f => f.key === item.keyparent)[0].icon ? false : item.icon)} : item      
    ))

    // Atualiza a exibição dos campos conforme seus keyparent expandidos
    newdata = newdata.map((item) => (
      item.tipo === "campo" ? {...item, open: newdata.filter(f => f.key === item.keyparent)[0].icon} : item 
    ))
    
    setCamposDataTable(newdata);
  }

  const headers = tableDetalhadoBI.map(m => (m.identificacao));

  const lines = camposDataTable.map(m => {
    let item = { ...m };
    item.values = headers.map(i => {
      const splitCode = m.codigo.split(".")//faz um split para acessar os campos que estão dentro de objetos aninhados como totalDespesaPieChart.totalPessoal
      if (splitCode.length > 1) {
        const [nestedObj, nestedProp] = splitCode;
        const nestedData = tableDetalhadoBI.find(f => f.identificacao === i)?.dados[nestedObj];//
        return nestedData ? nestedData[nestedProp] : undefined;
      } else {
        return tableDetalhadoBI.find(f => f.identificacao === i)?.dados[m.codigo];
      }
    });
    return item;
  });

  return (
    <div>
      <Row>
        <Col lg="12" md="12" sm="12">
          <div style={{ overflowX: 'auto', maxWidth: '100%' }}>
            <table no-border style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  {headers.map((item, key) => (
                    <th key={key} style={stylesTable["header"]}>
                      {item}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {lines.map((item, key) => (
                  item.open && (
                    <tr key={key} style={stylesTable[item.tipo]}>
                      <td style={stylesTable["botao"]}>
                      {(item.tipo === 'titulo' || item.tipo === 'subtitulo' || item.tipo === 'tituloIndicador') && item.label != "EBITDA" && item.label != "% EBITDA" && item.label != "QTD PDV" ?
                          <button onClick={() => OnOpenChild(item.key, item.keyparent)} 
                          className="botaotableDre">
                            {item.icon ? <RemoveIcon/> : <AddIcon/>} </button> :
                          <button style={{ opacity: 0, display: 'none' }} ><AddIcon  /></button>
                        }
                      </td>
                      <td style={stylesTable["tableFirstCollum"]}>
                        {item.label}
                      </td>
                      {item.values.map((m, index) => {
                        if (m == undefined)
                          m = 0;
                        const shouldFormatCurrency = !item.label.includes('QTD') && !item.label.includes('%')
                        const formattedValue = typeof m === 'number' && item.label === '% EBITDA'
                          ? m.toFixed(1)
                          : m;
                        return (
                          <td key={index} style={stylesTable["tableColluns"]}>
                            <strong>
                              {typeof m === 'number' && shouldFormatCurrency
                                ? parseFloat(formattedValue).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                                : formattedValue}
                            </strong>
                          </td>
                        );
                      })}
                    </tr>
                  )
                ))}
              </tbody>
            </table>
          </div>

        </Col>
      </Row>
    </div>
  );
}

const stylesTable = {
  header: {width:"100px", backgroundColor: "#878786", color: "#fff", opacity: 0.7 },
  titulo: { backgroundColor: "#0B3D86", color: "#fff", opacity: 0.7 },
  subtitulo: { backgroundColor: "#CECECC" },
  campo: {},
  tituloIndicador: { backgroundColor: "#0B3D86", color: "#fff" },
  tableFirstCollum: { padding: "8px", width: "150px" },
  tableColluns: { padding: "8px" },
  botao: { maxWidth: '30px', width: "30px", minWidth: '30px'  }
};
